import { TabNav } from '@customerio/pluma-components/react';
import { useLocation } from 'react-router-dom';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { useSafeNavigate } from '@/services/router/safe-navigate';

export function EmailSettingsTabs() {
  const location = useLocation();
  const safeNavigate = useSafeNavigate();
  const workspaceId = getWorkspaceIdFromCurrentUrl();

  const tabs = [
    {
      href: `/workspaces/${workspaceId}/settings/actions/email/sending_domains`,
      text: 'Sending domains',
      isActive: location.pathname === `/workspaces/${workspaceId}/settings/actions/email/sending_domains`,
    },
    {
      href: `/workspaces/${workspaceId}/settings/actions/email/smtp`,
      text: 'Custom SMTP',
      isActive: location.pathname === `/workspaces/${workspaceId}/settings/actions/email/smtp`,
    },
    {
      href: `/workspaces/${workspaceId}/settings/actions/email/suppression_list`,
      text: 'Suppression list',
      isActive: location.pathname === `/workspaces/${workspaceId}/settings/actions/email/suppression_list`,
    },
    {
      href: `/workspaces/${workspaceId}/settings/actions/email/defaults`,
      text: 'Default email settings',
      isActive: location.pathname === `/workspaces/${workspaceId}/settings/actions/email/defaults`,
    },
    {
      href: `/workspaces/${workspaceId}/settings/actions/email/account_verification`,
      text: 'Account verification',
      isActive: location.pathname === `/workspaces/${workspaceId}/settings/actions/email/account_verification`,
    },
  ];

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement;
    const anchor = target.closest('a');

    if (anchor == null) return;
    if (event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

    event.preventDefault();
    const href = anchor.getAttribute('href');
    if (href != null) {
      safeNavigate(href);
    }
  };

  return (
    <div onClick={handleClick}>
      <TabNav tabs={tabs} />
    </div>
  );
}
